/* Artonis: mui ten dieu huong cho cac carousel native-scroll tren mobile
   (.swipe-mobile va .exhibition-grid--mobile-carousel). Chay 1 lan, quet ca trang. */
(function () {
  if (window.__artonisCarouselNav) return;
  window.__artonisCarouselNav = true;

  var MQ = window.matchMedia('(max-width: 767.98px)');

  function firstItem(scroller) {
    var inner = scroller.querySelector('.swipe-mobile__inner');
    return inner ? inner.firstElementChild : scroller.firstElementChild;
  }

  function step(scroller) {
    var item = firstItem(scroller);
    if (!item) return scroller.clientWidth * 0.8;
    var s = getComputedStyle(item);
    var gap = (parseFloat(s.marginRight) || 0) + 12;
    return item.getBoundingClientRect().width + gap;
  }

  // Dung dung SVG icon-slider cua theme -> dong bo + can giua chuan (khong lech nhu glyph text)
  var SVG_PREV = '<svg class="icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.75 16.2505L6.5 10.0005L12.75 3.75049" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_NEXT = '<svg class="icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.5 3.74121L13.75 9.99121L7.5 16.2412" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function build(scroller) {
    if (scroller.__navBuilt) return;
    scroller.__navBuilt = true;

    var nav = document.createElement('div');
    nav.className = 'axc-nav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'axc-nav__btn axc-nav__btn--prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = SVG_PREV;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'axc-nav__btn axc-nav__btn--next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = SVG_NEXT;

    nav.appendChild(prev);
    nav.appendChild(next);
    if (scroller.parentNode) scroller.parentNode.insertBefore(nav, scroller.nextSibling);

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      nav.hidden = max <= 2;
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -step(scroller), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: step(scroller), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function run() {
    if (!MQ.matches) return;
    var list = document.querySelectorAll('.swipe-mobile, .exhibition-grid--mobile-carousel');
    Array.prototype.forEach.call(list, build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', run);
})();
